import { MenuItem, MenuItemProps, styled } from '@mui/material';

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  position: 'relative',
  paddingLeft: '35px',

  '&::before': {
    content: '""',
    display: 'block',
    width: '20px',
    height: '20px',
    borderRadius: '10px',
    left: 5,
    top: '50%',
    transform: 'translate(0, -50%)',
    border: `1px solid ${theme.palette.darkBlue.main}`,
    position: 'absolute',
  },

  [`&.active::after`]: {
    content: '""',
    display: 'block',
    width: '10px',
    height: '10px',
    background: theme.palette.darkBlue.main,
    borderRadius: '50%',
    left: 10,
    top: '50%',
    transform: 'translate(0, -50%)',
    position: 'absolute',
  },
}));

const RadioSelectItem: React.FC<MenuItemProps> = ({ value, selected, sx, children, ...props }) => (
  <StyledMenuItem {...props} className={selected ? 'active' : ''} sx={{ display: 'flex', flexDirection: 'row', ...sx }} value={value}>
    {children}
  </StyledMenuItem>
);

export default RadioSelectItem;
